/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';
import _ from 'underscore';

// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import ReactDOM from '@trello/react-dom-wrapper';

import { BoardTemplateBadge } from 'app/src/components/BoardTemplateBadge';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isTemplate = function (this: any) {
  return this.templateFlagEnabled && this.model.isTemplate();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderBoardTemplateReactSection = function (this: any) {
  $('.js-board-template-badge').append(this.boardTemplateBadgeDiv);
  return ReactDOM.render(
    this.boardTemplateBadgeComponent,
    this.boardTemplateBadgeDiv,
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderBoardTemplateBadge = function (this: any) {
  if (!this.model.isTemplate()) {
    if (this.boardTemplateBadgeDiv) {
      ReactDOM.unmountComponentAtNode(this.boardTemplateBadgeDiv);
      this.boardTemplateBadgeDiv = null;
      this.boardTemplateBadgeComponent = null;
    }
    return;
  }

  const previouslyRendered =
    this.boardTemplateBadgeDiv != null &&
    this.boardTemplateBadgeComponent != null;
  if (!previouslyRendered) {
    // Defer here since the target div that is being rendered by Backbone may
    // not be available yet.
    return _.defer(() => {
      this.boardTemplateBadgeComponent = <BoardTemplateBadge />;
      this.boardTemplateBadgeDiv = document.createElement('div');
      return this.renderBoardTemplateReactSection();
    });
  } else {
    return this.renderBoardTemplateReactSection();
  }
};
